/**
 * Labstep
 *
 * @module state/reducers/helpers/entities/entityUser
 * @desc Helpers for entityUser reducer
 */

import type { Action } from 'labstep-web/models/action.model';
import { mergeByIds } from 'labstep-web/state/reducers/helpers/utils';

export const deduplicateById = (
  array: { id: number; [key: string]: any }[],
) => {
  const map = new Map();

  // Iterate over the array and add each object to the map using its id as the key.
  // This automatically removes any duplicates as a map can only have unique keys.
  array.forEach((item) => map.set(item.id, item));

  // Convert the map values back to an array and return it.
  return Array.from(map.values());
};

/**
 * @description Adds newly created user_entity to entity_users_preview because
 * the backend can't handle the recursion and doesn't update entity_users_preview
 * correctly
 */
export const previewArrayUpdate = (
  state: any,
  action: Action,
): any => {
  const entityUser =
    action.payload.entities.entity_user[action.payload.result];

  const entity =
    action.payload.entities[action.meta.parentName][
      action.meta.parentId
    ];

  const newEntities = {
    ...action.payload.entities[action.meta.parentName],
    [action.meta.parentId]: {
      ...entity,
      entity_users_preview: deduplicateById([
        ...entity.entity_users_preview,
        entityUser,
      ]),
    },
  };

  return mergeByIds(state, newEntities, action.meta.parentName);
};
